module.exports = __webpack_public_path__ + "img/seo-result1.963d0fe8.png";